import { render } from "./LoaderComponent.vue?vue&type=template&id=fafc2e64&scoped=true&ts=true"
import script from "./LoaderComponent.vue?vue&type=script&lang=ts"
export * from "./LoaderComponent.vue?vue&type=script&lang=ts"

import "./LoaderComponent.vue?vue&type=style&index=0&id=fafc2e64&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fafc2e64"]])

export default __exports__